"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genderOptions = exports.initialState = exports.initStatus = exports.addFormField = exports.searchFormField = void 0;
exports.searchFormField = {
    limit: ''
};
exports.addFormField = {
    firstName: '',
    lastName: '',
    age: '',
    gender: '',
    birthDate: ''
};
exports.initStatus = {
    type: '',
    code: 0,
    dataId: '',
    data: '',
    mode: 'view'
};
exports.initialState = {
    globalStyle: {
        lineHeight: 'loose',
        fontSize: 'medium',
        themeColor: 'normal'
    },
    searchFormField: exports.searchFormField,
    addFormField: exports.addFormField,
    searchResult: [],
    apiStatus: exports.initStatus,
    loadingState: false
};
exports.genderOptions = [
    { id: '0', name: '男' },
    { id: '1', name: '女' }
];
